import React from 'react';

export const ReadOnlyContext = React.createContext(false);
